/**
 * Google Sheets Integration Utility
 * Handles form submissions to Google Sheets via Google Apps Script
 */

// Google Apps Script URL - Replace with your deployed script URL
const GOOGLE_APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwxOhzAmYhRbDJ6Wd9h7ELY5I6A3R237wwm9Li42YyuSdblzP6DFC6-J1Trl5-ELn9lxg/exec";

/**
 * Submit form data to Google Sheets
 * @param {Object} data - Form data object
 * @param {string} formType - Type of form (e.g., 'contact', 'site-visit', 'newsletter')
 * @returns {Promise<Object>} Response with success/error status
 */
export const submitToGoogleSheets = async (data, formType = "general") => {
  try {
    // Add timestamp and form type to the data
    const dataWithMetadata = {
      ...data,
      formType,
      timestamp: new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
    };

    // Create FormData object for submission
    const formDataToSend = new FormData();
    
    // Append all data fields
    Object.keys(dataWithMetadata).forEach((key) => {
      formDataToSend.append(key, dataWithMetadata[key]);
    });

    // Submit to Google Apps Script
    const response = await fetch(GOOGLE_APPS_SCRIPT_URL, {
      method: "POST",
      body: formDataToSend,
      mode: "no-cors",
    });

    return {
      success: true,
      message: "Data submitted successfully to Google Sheets",
    };
  } catch (error) {
    console.error("Google Sheets submission error:", error);
    return {
      success: false,
      message: "Error submitting data to Google Sheets",
      error: error.message,
    };
  }
};

/**
 * Validate required fields in form data
 * @param {Object} data - Form data object
 * @param {Array<string>} requiredFields - Array of required field names
 * @returns {Object} Validation result with errors array
 */
export const validateFormData = (data, requiredFields = []) => {
  const errors = [];
  
  requiredFields.forEach((field) => {
    if (!data[field] || data[field].trim() === "") {
      errors.push(`${field} is required`);
    }
  });

  return {
    isValid: errors.length === 0,
    errors,
  };
};

/**
 * Format phone number (basic validation)
 * @param {string} phone - Phone number string
 * @returns {boolean} True if valid phone number
 */
export const isValidPhone = (phone) => {
  const phoneRegex = /^[0-9]{10}$/;
  return phoneRegex.test(phone.replace(/\D/g, ""));
};

/**
 * Format email address validation
 * @param {string} email - Email address
 * @returns {boolean} True if valid email
 */
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
